export const ALL_UNITS_VALUE = 'ALL_UNITS';

export const FIRST_UNIT_INDEX = 1;

export const TEST_ID = 'unitSelectPanelField';
